import clsx from "clsx";

const SIZE_CLASSES = {
  // Full-width form field — InventoryNew.jsx/InventoryDetail.jsx's inputCls pattern.
  md: "w-full px-3 py-2 text-sm focus:ring-2",
  // Compact inline field — GrowDetail.jsx's inline-edit pattern (dates, device pickers).
  sm: "px-2 py-1 text-sm focus:ring-1",
};

// Matches DESIGN.md's Inputs spec: control radius, gray-300 border, brand focus ring.
export default function Input({ size = "md", className, ...props }) {
  return (
    <input
      className={clsx(
        "rounded-control border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-400 focus:outline-none focus:ring-brand",
        SIZE_CLASSES[size],
        className
      )}
      {...props}
    />
  );
}
